import React from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import {
  authService,
  // inactivityTracker,
  markerIoUtil,
  validationUtil
  // protectedFileUtil
} from 'iron-forge-react-modules';

import { App } from './App';

import awsExports from './aws-exports.js';



async function __init() {
  await authService.init(awsExports);
  // protectedFileUtil.init(authService.getAccessTokenObservable());

  const envName = process.env.REACT_APP_ENV_NAME;
  // if (_.includes(['edge', 'dev', 'prod'], envName)) {
  //   await inactivityTracker.init();
  // }

  if (envName === 'dev' || envName === 'prod') {
    // Wrapped in a try/catch because marker can throw an error
    try {
      await markerIoUtil.init();
    } catch (err) {
    }
  }

  validationUtil.init();

  const container = document.getElementById('root');

  if (container) {
    const root = createRoot(container);
    root.render((
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    ));
  }
}
__init();
